import { render, staticRenderFns } from "./productawardForm.vue?vue&type=template&id=87b61a06&scoped=true"
import script from "./productawardForm.vue?vue&type=script&lang=js"
export * from "./productawardForm.vue?vue&type=script&lang=js"
import style0 from "./productawardForm.vue?vue&type=style&index=0&id=87b61a06&prod&lang=scss&scoped=true"
import style1 from "./productawardForm.vue?vue&type=style&index=1&id=87b61a06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b61a06",
  null
  
)

export default component.exports